import { designSystemColors } from '@klv/shared/styles/colors';
import fonts from '@klv/shared/styles/fonts';
import { clampSize } from '@klv/shared/utils/functions';

const stat = {
  dark: {
    border: designSystemColors.lemon,
    subcopy: designSystemColors.white,
    subHeadline: designSystemColors.lemon,
  },
  font: {
    fontFace: fonts.sohne.regular,
    fontSize: clampSize(3.4, 8.2),
    lineHeight: 1.2,
  },
  light: {
    border: designSystemColors.poppy,
    subcopy: designSystemColors.charcoal,
    subHeadline: designSystemColors.charcoal,
  },
};

export default stat;
